
import React, { useEffect, useRef } from 'react';

interface BannerAdProps {
  format?: 'auto' | 'horizontal' | 'vertical' | 'rectangle';
  slot?: string;
  className?: string;
}

const BannerAd: React.FC<BannerAdProps> = ({ 
  format = 'auto', 
  slot = '1234567890', 
  className = 'w-full h-auto min-h-[90px] bg-gray-100'
}) => {
  const adRef = useRef<HTMLDivElement>(null);
  
  useEffect(() => {
    try {
      if (adRef.current && typeof window !== 'undefined') {
        const adsbygoogle = window.adsbygoogle || [];
        adsbygoogle.push({});
      }
    } catch (e) {
      console.error('AdSense error:', e);
    }
  }, []);

  return (
    <div className={className}>
      <ins
        ref={adRef as any}
        className="adsbygoogle"
        style={{ display: 'block', width: '100%', height: '100%' }}
        data-ad-client="ca-pub-7154913530427560"
        data-ad-slot={slot}
        data-ad-format={format}
        data-full-width-responsive="true"
      />
    </div>
  );
};

export default BannerAd;
